import styled from 'styled-components';

export const ColorCircle = styled.div<{
  width?: number;
  borderRadius?: number;
}>`
  height: ${props => props.width || 20}px;
  width: ${props => props.width || 20}px;
  border-radius: ${props => props.borderRadius || 10}px;
  background-color: ${props => props.color};
  margin-right: 8px;
`;

export const PatternCircle = styled.img<{
  width?: number;
  borderRadius?: number;
}>`
  height: ${props => props.width || 20}px;
  width: ${props => props.width || 20}px;
  border-radius: ${props => props.borderRadius || 10}px;
  margin-right: 8px;
`;
